const MobileDetect = require('mobile-detect')
const getCurrentRenderer = function() {
  let md = new MobileDetect(window.navigator.userAgent);
  if(md.tablet()){
    return 'pad'
  } else {
    if(md.mobile()){
      return 'mobile'
    }
  }
  return 'pc'
}
const siteRenderer = getCurrentRenderer()

// initial state
const state = {
  isMenuCollapsed: siteRenderer != 'pc',
  siteRenderer: siteRenderer,
  isShowIFrame: false,
  allIFrames: [],
  currentIFrame: null
}

let taskPtr = null
window.addEventListener('resize', function(){
  if(taskPtr){
    window.clearTimeout(taskPtr)
  }
  taskPtr = window.setTimeout(function(){
    state.siteRenderer = getCurrentRenderer()
  }, 50)
}, false)

// getters
const getters = {
	isMenuCollapsed: state => state.isMenuCollapsed,
  siteRenderer: state => state.siteRenderer,
  isShowIFrame: state => state.isShowIFrame,
  allIFrames: state => state.allIFrames,
  currentIFrame: state => state.currentIFrame
}

// actions
const actions = {
  setMenuCollapsedState ({ commit }, isMenuCollapsed) {
    commit('setMenuCollapsedState', isMenuCollapsed)
  },
  setIsShowIFrame ({ commit }, isShowIFrame) {
    commit('setIsShowIFrame', isShowIFrame)
  },
  pushIFrameUrl ({ commit }, url) {
    commit('pushIFrameUrl', url)
  }
}

// mutations
const mutations = {
  setMenuCollapsedState (state, isMenuCollapsed) {
    state.isMenuCollapsed = isMenuCollapsed
  },
  setIsShowIFrame (state, isShowIFrame) {
    state.isShowIFrame = isShowIFrame
  },
  pushIFrameUrl (state, url) {
    if(url) {
      if(state.allIFrames.indexOf(url) < 0) {
        state.allIFrames.push(url)
      }
      state.currentIFrame = url
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
